// ScrollToTop.jsx
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ scrollRef }) => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if (scrollRef && scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [pathname, scrollRef]);

  return null;
};

export default ScrollToTop;
